<template>
  <div class="uk-margin-medium-top" uk-grid>
    <div class="uk-width-1-1">
      <Card :removeFooterDivider="true" removeHeaderDivider="true">
        <template v-slot:header>
          <h2>Tickets</h2>

          <div class="uk-width-expand ba-remove-parent-header-padding">
            <div class="ba-card-header-tabs">
              <ul class="uk-flex-left" uk-tab>
                <li @click="selected_filter = 'all'" :class="{'uk-active':selected_filter == 'all'}"><a>all</a></li>
                <li @click="selected_filter = 'open'" :class="{'uk-active':selected_filter == 'open'}"><a>open</a></li>
                <li @click="selected_filter = 'in progress'" :class="{'uk-active':selected_filter == 'in progress'}"><a>in progress</a></li>
                <li @click="selected_filter = 'awaiting reply'" :class="{'uk-active':selected_filter == 'awaiting reply'}"><a>awaiting reply</a></li>
                <li @click="selected_filter = 'closed'" :class="{'uk-active':selected_filter == 'closed'}"><a>closed</a></li>
              </ul>
            </div>
          </div>

        </template>

        <template v-slot:body>
          <div class="uk-overflow-auto ba-height-min-large" v-if="tickets.length > 0">
            <table class="uk-table uk-table-divider uk-table-hover uk-table-middle uk-table-large">
              <thead>
                <tr>
                  <th class="uk-width-small">Ticket #</th>
                  <th class="uk-table-expand uk-text-nowrap">Summary</th>
                  <th class="uk-width-small">Priority</th>
                  <th class="uk-width-small">Opened</th>
                  <th class="uk-width-small">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ticket, index) in filtered_tickets" :key="index">
                  <td class="uk-table-link">
                    <router-link class="uk-link-reset" :to="{ name: 'ViewTicket', params: { id: ticket.id } }">{{ ticket.id }}</router-link>
                  </td>
                  <td class="uk-table-link uk-text-nowrap">
                    <router-link class="uk-link-reset" :to="{ name: 'ViewTicket', params: { id: ticket.id } }">{{ ticket.summary }}</router-link>
                  </td>
                  <td>
                    <router-link class="uk-link-reset" :to="{ name: 'ViewTicket', params: { id: ticket.id } }">{{ ticket.priority }}</router-link>
                  </td>
                  <td>
                    <router-link class="uk-link-reset" :to="{ name: 'ViewTicket', params: { id: ticket.id } }">{{ ticket.date_added.slice(0, 10) | formatDate }}</router-link>
                  </td>
                  <td>
                    <router-link class="uk-link-reset" :to="{ name: 'ViewTicket', params: { id: ticket.id } }">{{ ticket.status }}</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ba-height-min-large uk-flex uk-flex-middle" uk-grid v-else>
            <div class="uk-width-1-1">
              <div class="uk-text-center">
                <span uk-icon="icon: question; ratio: 5.25"></span>
                <h4 class="uk-h4 uk-text-muted">You don't have any tickets yet.</h4>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <div class="uk-flex-center" uk-grid>
            <div class="uk-width-1-4@xl uk-width-1-2@s">
              <BitButton :to="{ name: 'CreateTicket' }">Create New Ticket</BitButton>
            </div>
          </div>
        </template>

      </Card>
    </div>
  </div>
</template>

<script>
import BitButton from '@/components/common/button.vue';
import Card from '@/components/common/card.vue';

import { mapActions, mapState } from "vuex";

export default {
  name: 'Tickets',
  components: {
    BitButton,
    Card,
  },
  data() {
    return {
      selected_filter: 'all'
    }
  },
  computed: {
    ...mapState('tickets', ['tickets']),
    filtered_tickets() {
      if (this.selected_filter == 'all')
        return this.tickets
      else
        return this.tickets.filter( (ticket) => ticket.status == this.selected_filter)
    }
  },
  created() {
    this.GET_TICKETS();
  },
  methods: {
    ...mapActions('tickets', ['GET_TICKETS']),
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";

.uk-tab {
  margin: 0;
  border-bottom: 1px solid @ba-off-white;
  > * {
    > a {
      display: block;
      text-align: center;
      padding: 9px 20px;
      border-bottom: 2px solid transparent;
      font-size: 12px;
      text-transform: uppercase;
      transition: color .1s ease-in-out;
      line-height: 20px;
    }
  }
  > .uk-active {
    > a {
      color: #222;
      border-color: @ba-purple;
    }
  }
}
.uk-table {
  margin-top: 0;
}
.ba-remove-parent-header-padding {
  margin-left: -40px;
  margin-right: -40px;
  margin-bottom: -20px;
}
.ba-card-header-tabs {
  width: ~'calc(100% + 80px)';
}
</style>
